import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideJwtAuthentication } from '@softline/auth';
import {
  provideDarkTheme,
  remoteConfigProviders,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders } from '@softapps/allgemein/password';
import { loginProviders } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { wwsCoreProviders } from '@softapps/wws/core';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { inventurProviders } from '@softapps/mde/inventur';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { retourenProviders } from '@softapps/mde/retouren';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { platform } from '../platforms/platform';
import { provideSoftApps, SOFTLINE_CONFIG_PUBLIC_SHELL_BRANDING } from '@softapps/core';
import { artikelvorratProviders } from '@softapps/mde/artikelvorrat';
import { energietransportProviders } from '@softapps/wws/energietransport';
import { lieferscheinProviders } from '@softapps/wws/lieferschein';
import { provideGarageOrderModule } from '@softapps/werkstatt/order';
import { pmsStempelTerminalProviders } from '@softapps/pms/stempel-terminal';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { gesamtabfrageProviders } from '@softapps/wws/gesamtabfrage';
import { dashboardProviders } from '@softapps/allgemein/dashboard';
import { provideSalesStatisticsModule } from '@softapps/wws/sales-statistics';
import { stempelerfassungProviders } from '@softapps/pms/stempelerfassung';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideSoftApps({ connection: environment.connection }),
    provideJwtAuthentication(),
    ...loginProviders,

    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'lagerhaus' },

    { provide: SOFTLINE_CONFIG_PUBLIC_SHELL_BRANDING, useValue: true },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'lagerhaus',
        name: 'Lagerhaus',
      },
      multi: true,
    },

    // Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,

    ...gesamtabfrageProviders,
    ...dashboardProviders,
    provideSalesStatisticsModule(),

    ...settingsProviders,
    ...remoteConfigProviders,
    ...passwordProviders,
    ...loginProviders,
    ...moduleProviders,

    // MDE
    ...wwsCoreProviders,

    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...etikettendruckProviders,
    ...inventurProviders,
    ...warenverprobungProviders,
    ...retourenProviders,
    ...artikelvorratProviders,
    ...provideStorageLocation(),

    ...artikelInfoProviders,

    ...energietransportProviders,
    ...lieferscheinProviders,
    provideGarageOrderModule(),

    ...pmsStempelTerminalProviders,
    ...stempelerfassungProviders,

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
